export default "__VITE_ASSET__xcu08zcr__"